import {
  PrintInfo,
  PrintStatus,
} from "../../../../../common/api/decimal/methods/course.ts";
import { optedOutWithoutBook, optedOutWithBook } from "../printStatusHelper.ts";
import styles from "./BookStoreHours.module.scss";
import { FormattedMessage } from "react-intl";

const BookStoreHours = ({
  printStatus,
  printInfo: { location, hours, returnDate, pickupDate },
}: {
  printStatus: PrintStatus;
  printInfo: PrintInfo;
}) => {
  const returnDateAsDate = new Date(returnDate);
  const pickupDateAsDate = pickupDate ? new Date(pickupDate) : null;
  return (
    <div className={styles.bookstoreContainer}>
      <h2 className={styles.bookstoreHeader}>
        <FormattedMessage defaultMessage="Bookstore Location & Hours" />
      </h2>
      <div>
        <div>{location}</div>
        <div>
          <FormattedMessage
            defaultMessage="Hours: {hours}"
            values={{ hours }}
          />
        </div>
        <div>
          {optedOutWithoutBook(printStatus) && pickupDateAsDate && (
            <FormattedMessage
              defaultMessage="Pickup Window: {pickupDateAsDate, date, long} - {returnDateAsDate, date, long}"
              values={{ pickupDateAsDate, returnDateAsDate }}
            />
          )}
          {optedOutWithBook(printStatus) && (
            <FormattedMessage
              defaultMessage="Return by: {returnDateAsDate, date, long}"
              values={{ returnDateAsDate }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BookStoreHours;
